import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

const R = (v) => `R ${(Number(v) || 0).toFixed(2)}`;

const MonthTable = ({ rows, testid, tone }) => {
  const sum = (k) => rows.reduce((s, m) => s + (m[k] || 0), 0);
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead>
          <tr className={tone.head}>
            <th className="px-3 py-2 text-left font-medium">Month</th>
            <th className="px-3 py-2 text-right font-medium">Qty Sold</th>
            <th className="px-3 py-2 text-right font-medium">Turnover</th>
            <th className="px-3 py-2 text-right font-medium">Profit</th>
            <th className="px-3 py-2 text-right font-medium">Trans.</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((m, idx) => (
            <tr key={m.period || idx} className={idx % 2 === 0 ? "bg-white" : tone.stripe} data-testid={`${testid}-row-${idx}`}>
              <td className={`px-3 py-2 font-medium ${tone.text}`}>
                {m.period_label}{m.is_current_month && <span className="ml-1 text-xs text-slate-500">(so far)</span>}
              </td>
              <td className="px-3 py-2 text-right font-semibold">{(m.qty_sold || 0).toFixed(2)}</td>
              <td className="px-3 py-2 text-right">{R(m.turnover)}</td>
              <td className={`px-3 py-2 text-right ${(m.profit || 0) >= 0 ? "text-green-600" : "text-red-600"}`}>{R(m.profit)}</td>
              <td className="px-3 py-2 text-right text-gray-500">{m.transactions || 0}</td>
            </tr>
          ))}
        </tbody>
        <tfoot className={`${tone.head} font-semibold`}>
          <tr>
            <td className="px-3 py-2">Total</td>
            <td className="px-3 py-2 text-right">{sum("qty_sold").toFixed(2)}</td>
            <td className="px-3 py-2 text-right">{R(sum("turnover"))}</td>
            <td className={`px-3 py-2 text-right ${sum("profit") >= 0 ? "text-green-600" : "text-red-600"}`}>{R(sum("profit"))}</td>
            <td className="px-3 py-2 text-right text-gray-500">{sum("transactions")}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export const RecentSalesPanels = ({ recent = [], imported = [] }) => {
  const [showImported, setShowImported] = useState(false);
  const avg = recent.length ? recent.slice(1).reduce((s, m) => s + (m.qty_sold || 0), 0) / Math.max(1, recent.length - 1) : 0;
  return (
    <>
      {recent.length > 0 && (
        <div className="bg-sky-50 p-4 rounded-lg border border-sky-200" data-testid="recent-sales-panel">
          <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
            <h3 className="font-semibold text-sky-900">Sales — last {recent.length} months</h3>
            <span className="text-xs text-sky-800" data-testid="recent-sales-avg">
              Avg {avg.toFixed(1)} units / month (last {recent.length - 1} full months)
            </span>
          </div>
          <MonthTable rows={recent} testid="recent-sales-table" tone={{ head: "bg-sky-100 text-sky-900", stripe: "bg-sky-50", text: "text-sky-800" }} />
        </div>
      )}
      {imported.length > 0 && (
        <div className="bg-purple-50 rounded-lg border border-purple-200">
          <button
            type="button"
            className="w-full flex items-center gap-2 p-3 text-left text-sm font-semibold text-purple-800"
            onClick={() => setShowImported((v) => !v)}
            data-testid="imported-history-toggle"
          >
            {showImported ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
            Older imported sales history ({imported.length} months)
          </button>
          {showImported && (
            <div className="px-4 pb-4">
              <MonthTable rows={imported} testid="imported-history-table" tone={{ head: "bg-purple-100 text-purple-800", stripe: "bg-purple-50", text: "text-purple-700" }} />
            </div>
          )}
        </div>
      )}
    </>
  );
};
